import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import GamificationService from '../services/GamificationService';

const WeeklyChallengeDisplay = () => {
  const { api } = useAuth();
  const [challenge, setChallenge] = useState(null);

  useEffect(() => {
    const load = async () => {
      if (!api) return;
      const svc = GamificationService.getInstance();
      svc.setApi(api);
      const data = await svc.getChallenge();
      setChallenge(data.challenge);
    };
    load();
  }, [api]);

  if (!challenge) return null;

  return (
    <div
      className="text-center py-2 px-4 rounded-xl bg-gradient-to-r from-teal-50 to-emerald-50 border border-teal-100"
      data-testid="weekly-challenge"
    >
      <p className="text-sm text-teal-700">
        <span className="text-base">&#127919;</span>{' '}
        <span className="font-medium">Défi cette semaine :</span>{' '}
        {challenge.description}
      </p>
    </div>
  );
};

export default WeeklyChallengeDisplay;
